// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------
| Copyright (c) 2014-2017, PhosphorJS Contributors
|
| Distributed under the terms of the BSD 3-Clause License.
|
| The full license is in the file LICENSE, distributed with this software.
|----------------------------------------------------------------------------*/


.p-DockPanel {
  z-index: 0;
}


.p-DockPanel-widget {
  z-index: 0;
}


.p-DockPanel-tabBar {
  z-index: 1;
}


.p-DockPanel-handle {
  z-index: 2;
}


.p-DockPanel-handle.p-mod-hidden {
  display: none !important;
}


.p-DockPanel-handle:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: '';
}


.p-DockPanel-handle[data-orientation='horizontal'] {
  cursor: ew-resize;
}


.p-DockPanel-handle[data-orientation='vertical'] {
  cursor: ns-resize;
}


.p-DockPanel-handle[data-orientation='horizontal']:after {
  left: 50%;
  min-width: 8px;
  transform: translateX(-50%);
}


.p-DockPanel-handle[data-orientation='vertical']:after {
  top: 50%;
  min-height: 8px;
  transform: translateY(-50%);
}


.p-DockPanel-overlay {
  z-index: 3;
  box-sizing: border-box;
  pointer-events: none;
}


.p-DockPanel-overlay.p-mod-hidden {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@phosphor/widgets/style/dockpanel.css"],"names":[],"mappings":"AAAA;;;;;;8EAM8E;;;AAG9E;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;AACZ;;;AAGA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,SAAS;EACT,cAAc;EACd,2BAA2B;AAC7B;;;AAGA;EACE,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;;AAGA;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;AACtB;;;AAGA;EACE,wBAAwB;AAC1B","sourcesContent":["/*-----------------------------------------------------------------------------\n| Copyright (c) 2014-2017, PhosphorJS Contributors\n|\n| Distributed under the terms of the BSD 3-Clause License.\n|\n| The full license is in the file LICENSE, distributed with this software.\n|----------------------------------------------------------------------------*/\n\n\n.p-DockPanel {\n  z-index: 0;\n}\n\n\n.p-DockPanel-widget {\n  z-index: 0;\n}\n\n\n.p-DockPanel-tabBar {\n  z-index: 1;\n}\n\n\n.p-DockPanel-handle {\n  z-index: 2;\n}\n\n\n.p-DockPanel-handle.p-mod-hidden {\n  display: none !important;\n}\n\n\n.p-DockPanel-handle:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  content: '';\n}\n\n\n.p-DockPanel-handle[data-orientation='horizontal'] {\n  cursor: ew-resize;\n}\n\n\n.p-DockPanel-handle[data-orientation='vertical'] {\n  cursor: ns-resize;\n}\n\n\n.p-DockPanel-handle[data-orientation='horizontal']:after {\n  left: 50%;\n  min-width: 8px;\n  transform: translateX(-50%);\n}\n\n\n.p-DockPanel-handle[data-orientation='vertical']:after {\n  top: 50%;\n  min-height: 8px;\n  transform: translateY(-50%);\n}\n\n\n.p-DockPanel-overlay {\n  z-index: 3;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n\n.p-DockPanel-overlay.p-mod-hidden {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
